import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { CurrentDateWidget } from 'htv-lib'
import { Subscription } from 'rxjs'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import moment from 'moment'
import { MomentPipe } from '../../pipes/moment.pipe'

@Component({
  selector: 'app-current-date',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent, MomentPipe],
  templateUrl: './current-date.component.html',
  styleUrls: [],
})
export class CurrentDateComponent {
  subscriptions = new Subscription()
  @Input() config!: CurrentDateWidget

  text = ''
  date = moment()
}
